import { ExtendedRequirementDefinition } from "../../../../../query/requirementDefinitions/query/useExtendedRequirementDefinition";
import { getRequirementDefinitionTemplateByParams } from "../../../../RequirementDefinitions/utils";
import { selectorPolicyTypesFromSettings } from "./selectorPolicyTypesFromSettings";
import { InsuranceCoverageMonitorSettings } from "../../../../../services/api/insurance/monitor/types";

export const selectorTemplateParamsFromExtendedRequirementDefinition = (
  requirement: ExtendedRequirementDefinition
): Parameters<typeof getRequirementDefinitionTemplateByParams>[0] => {
  return {
    type: requirement.requirementType,
    contextType: requirement?.dataSource?.contextType,
    policyType: selectorPolicyTypesFromSettings(
      requirement?.dataSource as InsuranceCoverageMonitorSettings
    )
  };
};
